<div class="decline-mapping-grid-cells" *ngIf="row">
  <div
    class="dm-cell-inner"
    [class.dm-active]="active"
    [class.dm-has-items]="hasItems"
    (click)="onCellClick()"
    role="button"
    tabindex="0"
    (keydown)="onKeyActivate($event)"
  >
    <ng-container *ngIf="reasons.length === 0; else tagsTpl">
      <span class="dm-cell-empty">Click to map</span>
    </ng-container>
    <ng-template #tagsTpl>
      <span *ngFor="let reason of visibleReasons" class="dm-ctag" [title]="reason">
        <span class="dm-ctag-label">{{ reason }}</span>
        <span class="dm-ctag-x" (click)="onRemove(reason, $event)" title="Remove">×</span>
      </span>
      <span *ngIf="hiddenCount > 0" class="dm-ctag dm-ctag--more">
        And {{ hiddenCount }} more
      </span>
    </ng-template>
  </div>
</div>
